import React from 'react';
import { MdArrowDropDown, MdCheckBox } from 'react-icons/md';
import { DropdownMenu } from 'ui';
import { linkCodesAction, LinkCodesTranslation } from '../constants';
import { useListActionsCallbacks, useListSelectors, useMetadataSelectors } from '../hooks';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import styles from './list-header-visibility.scss';

interface ListHeaderActionsProps {
  includeInactive: boolean;
  translation: LinkCodesTranslation;
}

export const ListHeaderActions: React.FC<ListHeaderActionsProps> = ({
  includeInactive, translation
}) => {

  const { addListActions } = useListActionsCallbacks();
  const { selectedRows } = useListSelectors();
  const { metadata } = useMetadataSelectors();

  const toasts = toastFactory();

  const notify = (callback: () => void) => {
    if (!includeInactive) {
      toasts.dispatchInfo(translation.mark_all_info);
    } else {
      callback();
    }
  };

  const markAllSelected = () => {
    notify(() => addListActions([[]], linkCodesAction.selectAll, true));
  };

  const markAllUnselected = () => {
    notify(() => addListActions([[]], linkCodesAction.deselectAll, true));
  };

  const markHighlightedSelected = () => {
    addListActions(selectedRows, linkCodesAction.select, false);
  };

  const markHighlightedAndChildrenSelected = () => {
    addListActions(selectedRows, linkCodesAction.select, true);
  };

  const markHighlightedUnselected = () => {
    addListActions(selectedRows, linkCodesAction.deselect, true);
  };

  const buttonNode = <div className={styles.hasMaxWidth}>
    <MdCheckBox className={styles.visibilityIcon} />
    <span className={styles.visibilityLabel}>{translation.mark_rows}</span>
    <MdArrowDropDown className="dropdown-arrow" />
  </div>;

  return <DropdownMenu dropdownNode={buttonNode} closeAfterClick>
    <li>
      <button id="mark-all-selected" className="dropdown-item" type="button" onClick={markAllSelected}>
        {translation.mark_all_selected}
      </button>
    </li>
    <li>
      <button id="mark-all-unselected" className="dropdown-item" type="button" onClick={markAllUnselected}>
        {translation.mark_all_unselected}
      </button>
    </li>
    <li>
      <button id="mark-highlighted-selected" className="dropdown-item" type="button" onClick={markHighlightedSelected}>
        {translation.mark_highlighted_selected}
      </button>
    </li>
    {!!metadata?.hierarchy && <li>
      <button id="mark-highlighted-and-children-selected" className="dropdown-item" type="button"
        onClick={markHighlightedAndChildrenSelected}>
        {translation.mark_highlighted_children_selected}
      </button>
    </li>}
    <li>
      <button id="mark-highlighted-unselected" className="dropdown-item" type="button" onClick={markHighlightedUnselected}>
        {translation.mark_highlighted_unselected}
      </button>
    </li>
  </DropdownMenu>;
};
